<script>

import jwt_decode from "jwt-decode";

export default {
   name: "Permission",

   data() {
      return {
         idCompany: localStorage.getItem('companyId'),
         permissions: null,
      }
   },

   mounted() {
       this.permissions = jwt_decode(localStorage.getItem('access_token')).roles;
   },

   methods: {
      validatePermissions(permission) {
         var hasPermisson = false;

         if (this.permissions && permission != '') {
            this.permissions.forEach(per => {
               if (per == permission)
                  hasPermisson = true;
            });
         }

         return hasPermisson;
      },
   }
}

</script>
